import React from "react";
import MuiRadioGroup from "@material-ui/core/RadioGroup";

function RadioGroup({ classes, children, ...props }) {
  return <MuiRadioGroup {...props}>{children}</MuiRadioGroup>;
}

export default RadioGroup;
